import * as jsPDF from 'jspdf';
// import 'jspdf-autotable';
import { font } from './Montserrat-normal';
import { getScreenShot, takeScreenshot } from '@/lib/takeScreenshot';
import { useConfigurationStore } from '@/Store/storeConfiguration';
import { logo } from '@/pdf/logo64';
import { line } from '@/pdf/line';
import { useStoreData } from '@/Store/storeData';
import { $ } from '@/Engine/state';
import { useUIOnlyStore } from '@/Store/storeUI';
import { requestJsonGet } from '@/utils/httpRequest';
import { getPDFTableSchemeOptionByTitle, PDFcolumnsGap, tableScheme } from '@/pdf/tableOptions';


let positionY = 10;
const fontNormal = 15;
const fontMini=10;
let docWidth=0;
let docHeight=0;
const paddingLeft=14;
const paddingBottom=15;
const itemsPerPage=17;
let textGap=6;
let priceImageSize=11;
let baseTableItemHeight=10;
let itemTextXpos=45;
let pageCount=0;
let doc = {};
const splitTextWidthMinus=5;

export async function createPdf(itemsArr, currencySymbol, externalUser) {
    // const requestOptions = {
    //     method: 'GET',
    //     headers: {
    //         'Content-Type': 'application/json',
    //     },
    // };
    //
    // const response = await fetch(url, requestOptions);
    // const responseJson = await response.text();
    // return JSON.parse(responseJson);
    // window.configurator.postMessage({ configurator: { action: 'setContacts' }, data: {} }, '*');

    let itemsAll = [ ...itemsArr ];
    const allItemIDs = useConfigurationStore().getAllItemIDs;
    const storeData = useStoreData();
    const categories = storeData.getCategories;

    const getAccessoriesByCategoryId = (categoryId) => {
        return storeData.getAccessoriesByCategoryId(categoryId);
    };

    const acc178 = getAccessoriesByCategoryId(178);
    const acc22 = getAccessoriesByCategoryId(22);

    const extraItems = [];
    [ ...Object.entries(acc178), ...Object.entries(acc22) ].forEach(([ id, count ]) => {
        const item = storeData.getItemsByIdArr([ +id ])[0];
        if (item) {
            extraItems.push({ ...JSON.parse(JSON.stringify(item)), count });
        }
    });

    let items = [ ...itemsAll, ...extraItems ];
    positionY = 10;
    doc=new jsPDF({
        // orientation: 'l',
        unit: 'mm',
        format: 'a4',
        putOnlyUsedFonts: true,
    });
    //Setup
    docWidth=doc.internal.pageSize.getWidth();
    docHeight=doc.internal.pageSize.getHeight();
    doc.addFileToVFS('Montserrat.ttf', font);
    doc.addFont('Montserrat.ttf', 'Montserrat', 'normal');
    doc.setFont('Montserrat');
    doc.setFontSize(fontNormal);
    //Scene screen
    pageCount=1;
    let contacts=window.contacts;
    if (!contacts) contacts={
        address:'',phones:'',emails:'',url:'',logo:'',company_name: '',
    };
    console.log(contacts);
    addLogo();
    doc.text('Ваш проект ' + useConfigurationStore().getProjectName + ':', paddingLeft, positionY, null, null);
    nextTextLine();
    let dateTime = new Date();
    doc.text('Проект создан ' + dateTime.toLocaleDateString('en-GB') + ' в ' + dateTime.toLocaleTimeString(), paddingLeft, positionY, null, null);
    nextTextLine();
    let screenScans=[];

    useUIOnlyStore().setLoader(true);
    takeScreenshot();
    await window.wardrobe.moveCamera('front');
    if(useConfigurationStore().room.frontWallWidth>0 && !$.room.isEmpty('front'))
        screenScans.push({ imagePath:getScreenShot(),aspect:$.room.getWidth('front')/$.room.getHeight('front') });
    await window.wardrobe.moveCamera('left');
    if(useConfigurationStore().room.leftWallWidth>0 && !$.room.isEmpty('left'))
        screenScans.push({ imagePath:getScreenShot(),aspect:$.room.getWidth('left')/$.room.getHeight('left') });
    await window.wardrobe.moveCamera('right');
    if(useConfigurationStore().room.rightWallWidth>0 && !$.room.isEmpty('right'))
        screenScans.push({ imagePath:getScreenShot(),aspect:$.room.getWidth('right')/$.room.getHeight('right') });
    await window.wardrobe.moveCamera('back');
    if(useConfigurationStore().room.backWallWidth>0 && !$.room.isEmpty('back'))
        screenScans.push({ imagePath:getScreenShot(),aspect:$.room.getWidth('back')/$.room.getHeight('back') });
    await window.wardrobe.moveCamera('standard');

    useUIOnlyStore().setLoader(false);
    let screenImage = new Image();
    screenImage.src = window.screen__img;
    const screenHeight=(document.documentElement.clientHeight/document.documentElement.clientWidth)*(docWidth-paddingLeft*2);
    doc.addImage(screenImage, 'PNG', paddingLeft, positionY, docWidth-paddingLeft*2, screenHeight);
    positionY+=screenHeight;
    nextTextLine();
    doc.text('Стоимость проекта: ' + useStoreData().getCost.toFixed(2) + ' ' + currencySymbol, paddingLeft, positionY, null, null);
    nextPage();
    screenScans.forEach((screen,index)=>{
        const standart=230;
        const widthLim=docWidth-paddingLeft*2;
        let imgFrameWidth= standart*screen.aspect;
        let imgFrameHeight=standart;
        if(imgFrameWidth>widthLim) {
            const newScale=imgFrameWidth/widthLim;
            imgFrameWidth=widthLim;
            imgFrameHeight=imgFrameHeight/newScale;
        }
        doc.text('Развертка стены ' + (index+1), paddingLeft, positionY, null, null);
        nextTextLine();
        doc.addImage(screen.imagePath, 'PNG', paddingLeft, positionY, imgFrameWidth, imgFrameHeight);
        nextTextLine();
        nextPage();
    });
    //Price list
    //Make header
    // doc.text('Комплектация:', paddingLeft, positionY, null, null);
    positionY+=5;
    doc.setFontSize(fontMini);
    // if (externalUser) {
    //     doc.text('ID', 15, positionY);
    // }
    // doc.text('Фото', getTextCenterPos(), positionY);
    // doc.text('Товар', 15 + pos + 17, positionY);
    // doc.text('Габариты', 97, positionY);
    // doc.text('Вес', 126, positionY);
    // doc.text('Цена за шт', 139, positionY);
    // doc.text('Кол-во', 163, positionY);
    // doc.text('Сумма', 180, positionY);
    let currentHeaderPosX=15;
    tableScheme.forEach((tableSchemeItem,index)=>{
        if(index===0&&!externalUser) return;
        const columnWidth=externalUser?tableSchemeItem.widthCompact:tableSchemeItem.widthDefault;
        const newPos=tableSchemeItem.isCenterHeader?getTextCenterPos(currentHeaderPosX,columnWidth,tableSchemeItem.text):currentHeaderPosX;
        doc.text(tableSchemeItem.text, newPos, positionY);
        currentHeaderPosX+=columnWidth+PDFcolumnsGap;
    });
    positionY+=5;
    addLine();
    //joska
    let finalPrice=0;
    let finalMass=0;
    let maxSize=0;
    // items.push(...useStoreData().getAccessories);
    // positionY+=3;
    items.forEach((item, index) => {
        addTableItem(item,index,!!externalUser,currencySymbol);
        //Считаем итоги
        finalPrice +=(Math.round(item.price * item.count * 100) / 100);
        finalMass += (+item.weigth * item.count);
        if (item.width > maxSize) maxSize = item.width;
        if (item.height > maxSize) maxSize = item.height;
        if (item.depth > maxSize) maxSize = item.depth;

        // Увеличиваем позицию с учетом дополнительной высоты текста
        // (index + 1) % itemsPerPage === 0
        if ((positionY+baseTableItemHeight)>=(docHeight-paddingBottom)) {
            positionY = 0;
            nextPage();
        } else if (index + 1 !== items.length) addLine();

    });
    addLine();
    //Общая цена, общий вес, максимальный габарит
    nextTextLine(textGap*2);
    doc.setFontSize(fontNormal);
    doc.text('' + finalPrice.toFixed(2)+' ' + currencySymbol, docWidth-paddingLeft-getTextSize('' + finalPrice.toFixed(2)+' ' + currencySymbol), positionY);
    doc.setFontSize(fontMini);
    nextTextLine(textGap);
    doc.text('Общий вес', docWidth-paddingLeft-getTextSize('Общий вес'), positionY);
    nextTextLine(textGap);
    finalMass = parseInt(finalMass * 100);
    finalMass = '' + parseInt(finalMass / 100) + '.' + parseInt(finalMass % 100);
    doc.text('' + finalMass+' кг.',docWidth-paddingLeft-getTextSize('' + finalMass+' кг.'), positionY);
    nextTextLine(textGap);
    // doc.text('' + finalPrice+' руб.', 169, positionY);
    nextTextLine(textGap);
    doc.text('Максимальный габарит заказа', docWidth-paddingLeft-getTextSize('Максимальный габарит заказа'), positionY);
    nextTextLine(textGap);
    doc.text('' + getTrueSize(maxSize) +' мм',docWidth-paddingLeft-getTextSize('' + maxSize+' мм'), positionY);
    nextTextLine(textGap);
    //Дополнительная информация
    addLine();
    nextTextLine(textGap*2);
    if (contacts.logo && contacts.logo.length) {
        doc.addImage(contacts.logo, 'PNG', paddingLeft, positionY, 35, 10);
        nextTextLine(24);
    }
    if (contacts.company_name && contacts.company_name.length) {
        doc.text('Название компании:', paddingLeft, positionY);
        nextTextLine(6);
        doc.text(contacts.company_name, paddingLeft, positionY);
        nextTextLine(6);
    }
    doc.text('Адрес:', paddingLeft, positionY);
    nextTextLine(textGap);
    doc.text(contacts.address, paddingLeft, positionY);
    nextTextLine(textGap);
    doc.text('Телефон:', paddingLeft, positionY);
    nextTextLine(textGap);
    // let currentPaddingLeft=paddingLeft;
    // contacts.phones.forEach(phone=>{
    //     doc.text(phone, currentPaddingLeft, positionY);
    //     currentPaddingLeft+=(doc.getTextWidth(phone)+5);
    // });
    // currentPaddingLeft=paddingLeft;
    doc.text(contacts.phones, paddingLeft, positionY);
    nextTextLine(textGap);
    doc.text('Email', paddingLeft, positionY);
    nextTextLine(textGap);
    doc.text(contacts.emails, paddingLeft, positionY);
    // contacts.emails.forEach(email=>{
    //     doc.text(email, currentPaddingLeft, positionY);
    //     currentPaddingLeft+=(doc.getTextWidth(email)+5);
    // });
    nextTextLine(textGap);
    doc.text(contacts.url, paddingLeft, positionY);
    nextTextLine(textGap*2);
    addLine();
    addNumerification();
    return doc;
}

function addLogo() {
    doc.addImage(logo, 'PNG', paddingLeft, positionY, 35, 10);
    nextTextLine();
    nextTextLine();
}
function nextTextLine(customGap=10) {
    if((positionY+customGap)>=(docHeight-paddingBottom)){
        nextPage();
    } else positionY += customGap;
}
function addLine() {
    doc.setDrawColor(0); // устанавливаем цвет линии на чёрный
    doc.setLineWidth(0.3); // устанавливаем ширину линии
    doc.line(paddingLeft, positionY, doc.internal.pageSize.width - paddingLeft,positionY); // рисуем линию от 10 пунктов слева до ширины листа минус 10 пунктов
}

function addTableItem(item, index, isCompact, currencySymbol) {
    let currentPosX = 15;

    // ID (только для компактного режима)
    if (isCompact) {
        addColumnContent(0, item.myId ? item.myId.toString() : 'null', currentPosX, positionY + 8);
        currentPosX += getColumnWidth(0, isCompact) + PDFcolumnsGap;
    }

    // Изображение
    if (item.image !== '') {
        addImage(item.image, item.name, currentPosX, positionY + 2);
    }
    currentPosX += getColumnWidth(1, isCompact) + PDFcolumnsGap;

    positionY += 8;

    // Название
    const additionalHeight = addItemTitle(item.name, isCompact, currentPosX);
    currentPosX += getColumnWidth(2, isCompact) + PDFcolumnsGap;

    // Остальные колонки
    const itemFinalPrice=Math.round(item.count * item.price * 100) / 100;
    const columns = [
        { index: 3, value: getTrueSize(item.width) + 'x' + getTrueSize(item.height) + 'x' + getTrueSize(item.depth) + ' мм' },
        { index: 4, value: item.weigth + ' кг.' },
        { index: 5, value: item.price + ' ' + currencySymbol },
        { index: 6, value: '' + item.count },
        { index: 7, value: '' + itemFinalPrice.toFixed(2) + ' ' + currencySymbol },
    ];

    columns.forEach(col => {
        addColumnContent(col.index, col.value, currentPosX, positionY);
        currentPosX += getColumnWidth(col.index, isCompact) + PDFcolumnsGap;
    });

    positionY += (priceImageSize - 5) + additionalHeight;
}

function addColumnContent(columnIndex, text, x, y,isCompact) {
    const column = tableScheme[columnIndex];
    const columnWidth = getColumnWidth(columnIndex, isCompact);
    const textPosition = column.isCenterContent ? getTextCenterPos(x, columnWidth, text) : x;
    doc.text(text, textPosition, y);
}

function getColumnWidth(columnIndex, isCompact) {
    const column = tableScheme[columnIndex];
    return isCompact ? column.widthCompact : column.widthDefault;
}

function addImage(imageSrc, itemName, x, y) {
    const img = new Image();
    img.src = imageSrc;
    try {
        doc.addImage(img, 'PNG', x, y, priceImageSize, priceImageSize);
    } catch (error) {
        console.error('Ошибка при добавлении изображения:', itemName, img);
    }
}
function nextPage() {
    doc.addPage();
    positionY = 10;
    addLogo();
    pageCount+=1;
}
export async function getBase64PDF(items, currencySymbol, externalUser) {
    return new Promise(function(resolve, reject) {
        createPdf(items, currencySymbol, externalUser).then(doc => {
            const base64data = doc.output('datauristring');
            resolve(base64data);
        }).catch((err) => {
            reject(err);
        });
    });
}
function addNumerification() {
    positionY = docHeight - 8;
    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(fontMini);
        const line='Страница: ' + i + ' из ' + pageCount;
        const lineWidth=doc.getTextWidth('Страница: ' + i + ' из ' + pageCount);
        doc.text(line,(docWidth/2)-(lineWidth/2),positionY);
    }
}
// Функция для разделения текста на строки по заданной ширине
function splitTitleToFitWidth(title, columnWidth) {
    const parts = title.split(' ');
    let currentLine = '';
    const resultParts = [];

    for (let i = 0; i < parts.length; i++) {
        const part = parts[i];
        const newLine = currentLine + (currentLine ? ' ' : '') + part;

        if (doc.getTextWidth(newLine) > columnWidth - splitTextWidthMinus) {
            if (currentLine) {
                resultParts.push(currentLine);
                currentLine = part;
            } else {
                // Если одно слово превышает ширину столбца
                resultParts.push(part);
                currentLine = '';
            }
        } else {
            currentLine = newLine;
        }
    }

    // Добавление последней строки, если она существует
    if (currentLine) {
        resultParts.push(currentLine);
    }

    return resultParts;
}

function addItemTitle(title, isCompact,startPos) {
    const optionData=getPDFTableSchemeOptionByTitle('Товар');
    const columnWidth = isCompact?optionData.widthCompact:optionData.widthDefault;
    const columnStartX = startPos;
    const lineHeight = 5; // Высота одной строки текста
    const baseHeight = 8; // Базовая высота для одного товара

    const titleWidth = doc.getTextWidth(title);

    if (titleWidth >= columnWidth - 7) {
        // Автоперенос по пробелу
        const resultParts = splitTitleToFitWidth(title, columnWidth);

        // Вычисляем необходимую высоту для текста
        const textHeight = resultParts.length * lineHeight;

        // Рисуем каждую строку
        resultParts.forEach((part, index) => {
            doc.text(part, columnStartX, positionY - 2.5 + (index * lineHeight));
        });

        // Возвращаем дополнительную высоту, которую занял текст
        const additionalHeight = Math.max(0, textHeight - baseHeight);
        return additionalHeight;
    } else {
        // Одна строка - используем текущую позицию
        doc.text(title, columnStartX, positionY);
        return 0;
    }
}

function getTextCenterPos(startXPos,columnWidth, text){
    return startXPos +(columnWidth/2- getTextSize(text)/2) ;
}

function getTextSize(text){
    return doc.getTextWidth(text);
}
function getTrueSize(size){
    return (size*1000).toFixed(0);
}
export const loadResultPDF = function(items, currencySymbol, externalUser) {
    return new Promise(function(resolve, reject) {
        createPdf(items, currencySymbol, externalUser).then(doc => {
            doc.save(useConfigurationStore().getProjectName+' отчёт.pdf');
            positionY=10;
            resolve();
        }).catch((err) => {
            reject(err);
        });
    });
};

